<template>
  <div class="fail">
    <div class="explanation bord-btm">
      <p>
        <translate>We have detected that you are using</translate>
        <span class="browser-name">{{ usersBrowserName }}</span>,
        <translate>Version</translate>
        : <span class="browser-version">{{ usersBrowserVersion }}</span>
        <translate>on</translate>
        <span class="browser-os">{{ usersOperatingSystem }}</span>
        <span class="browser-platform">({{ usersPlatform }})</span>
      </p>

      <p id="old-browser" v-if="oldBrowser">
        <translate>This is a good browser but it is out-of-date.</translate>
        <translate>It doesn't support features essential for using the virtual classroom.</translate>
        <template v-if="iOSDevice">We recommend you update your browser in the app store or update the software on your system.</template>
        <translate v-else>The good news is you can get a compatible browser for free by downloading the latest version via any of the links below.</translate>
      </p>

      <p id="bad-browser" v-if="badBrowser">
        <template v-if="iOSDevice">
          <template v-if="usersBrowserName !== 'safari'">
            <translate>On Apple devices, the only browser we support is Safari.</translate>
            <translate>Due to technical constraints with Safari, our support is currently experimental.</translate>
            <translate>This means that while we have developed our app to give you the best experience possible, the browser might cause technical problems that are beyond our control.</translate>
            <translate>Please try to enter your class using Safari and share the feedback of your experience with us afterwards.</translate>
          </template>
        </template>

        <template v-else>
          <translate>Unfortunately this browser doesn't support features essential for our virtual classroom.</translate>
          <translate>But the good news is you can get a compatible browser for free by downloading the latest version at any of the links below</translate>.
        </template>
      </p>

    </div>


    <div v-if="!iOSDevice" :class="['fix-this', skipOption ? 'col-xs-6 pad-no-lft' : '']">
      <h3 v-if="config.app === 'troubleshooter'" class="text-center" v-translate>Fix This</h3>
      <h4 v-if="config.app === 'virtualclassroom'" class="text-center" v-translate>Fix This</h4>
      <p v-translate>Download and install a browser from one of the links below.</p>
      <p class="hint" v-translate>* Hint: We recommend Google Chrome</p>

      <div class="col-md-4 col-sm-4 col-xs-6 text-center">
        <a :href="chromeLink" target="_blank">
          <h5>Chrome</h5>
          <img :src="`${this.staticUrl}/images/icons/browsers/chrome_${imageSize}x${imageSize}.png`" />
        </a>
      </div>
      <div class="col-md-4 col-sm-4 col-xs-6 text-center">
        <a :href="firefoxLink" target="_blank">
          <h5>Firefox</h5>
          <img :src="`${this.staticUrl}/images/icons/browsers/firefox_${imageSize}x${imageSize}.png`" />
        </a>
      </div>
      <div class="col-md-4 col-sm-4 col-xs-12 hidden-xs text-center">
        <a :href="operaLink" target="_blank">
          <h5>Opera</h5>
          <img :src="`${this.staticUrl}/images/icons/browsers/opera_${imageSize}x${imageSize}.png`" />
        </a>
      </div>

    </div>


    <div :class="['skip-test', iOSDevice ? 'col-xs-12 pad-no' : 'col-xs-6']" v-if="skipOption">
      <h3 v-if="config.app === 'troubleshooter'" class="text-center" v-translate>Skip Test</h3>
      <h4 v-if="config.app === 'virtualclassroom'" class="text-center" v-translate>Skip Test</h4>

      <p :class="{'text-left': config.app === 'virtualclassroom'}" v-translate>Support for your browser is experimental or out-of-date.</p>
      <p :class="{'text-left': config.app === 'virtualclassroom'}" v-translate>This means that while you can have a successful class, it is not guaranteed because your browser is missing several critical features.</p>
      <p :class="{'text-left': config.app === 'virtualclassroom'}" v-translate>If you would like to participate anyway, knowing you may have an inferior experience, click the button below to skip this test.</p>

      <div class="col-sm-12 col-xs-6 skip-btn">
        <button class="btn btn-md btn-warning float-center" v-translate @click="skipTest">Accept and Skip</button>
      </div>
    </div>



  </div>
</template>

<script>
  /**
  * Browser test fail explanation and solution
  */
  import TestFail from './TestFail.vue'

  export default {
    name: 'BrowserFail',

    extends: TestFail,

    data () {
      return {
        'testName': 'browserTest'
      }
    },

    props: {

      badBrowser: {
        'type': Boolean,
        'default': true
      },

      oldBrowser: {
        'type': Boolean,
        'default': false
      },

      imageSize: {
        'type': Number,
        'default': 128
      }
    },

    computed: {
      chromeLink () {
        if (this.usersPlatform === 'desktop') {
          return 'https://www.google.com/chrome/browser/desktop/index.html'
        } else {
          return 'https://play.google.com/store/apps/details?id=com.android.chrome'
        }
      },

      firefoxLink () {
        if (this.usersPlatform === 'desktop') {
          return 'https://www.mozilla.org/firefox/new/'
        } else {
          return 'https://play.google.com/store/apps/details?id=org.mozilla.firefox'
        }
      },

      operaLink () {
        if (this.usersPlatform === 'desktop') {
          return 'https://www.opera.com/computer'
        } else {
          return 'https://play.google.com/store/apps/details?id=com.opera.browser'
        }
      }

    }

  }
</script>

<style scoped lang="less">

  .browser-name {
    text-transform: capitalize;
  }

  .skip-btn {
    margin: auto;
    float: none;
  }

</style>

<docs></docs>

